<template>
  <div class="page-content Inventory">
    <h1 class="page-title">{{ $locale('sideMenu.reports.inventory') }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="6">
        <!-- <DatePickerGroup
          v-bind:start="startTime"
          v-bind:end="endTime"
          @setFatherDate="getDate"
        ></DatePickerGroup> -->
        <el-date-picker
          class="month-input"
          type="month"
          v-model="monthDate"
          format="yyyy-MM"
          value-format="timestamp"
          :clearable="false"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-col>
      <el-col :span="18">
        <el-button
          class="egl-btn-yellow"
          @click="search"
        >{{ $locale("global.search") }}</el-button>
        <el-button style="min-width: 200px; float: right;" class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>

    <div class="checkboxes">
      <el-checkbox v-model="isCheckZero">在庫が0のものを表示</el-checkbox>
      <el-checkbox v-model="isCheckBuy">販売中のもののみを表示</el-checkbox>
    </div>
    <div id="print">
      <div class="table-module">
      <div class="info-supplement-container">
        <h3 class="info-title">在庫一覧表（期間別）</h3>
        <el-tooltip content="在庫一覧表（期間別）" placement="top">
          <div class="icon"></div>
        </el-tooltip>
      </div>
      <div class="info-supplement-container">
        <el-row class="module-sms" :gutter="10" >
          <el-col :span="6">{{ $locale('trans.report.period') }}：{{ timeRange }}</el-col>
          <el-col :span="7">{{ $locale('global.cinemaName') }}：{{ cinemaName }}</el-col>
          <el-col :span="6">会社名：{{ brandName }}</el-col>
          <el-col :span="5">{{ $locale('trans.report.generatedate') }}：{{ createTime }}</el-col>
        </el-row>
      </div>
    </div>

    <div class="custom-border-table film-table stockList">
      <el-table
        class="egl-table list-table"
        style="width: 100%"
        :data="tableData"
        :border="true"
        :span-method="objectSpanMethod"
        ref="stockTable"
        @filter-change="filter"
      >
        <el-table-column
          v-for="(item, idx) in tableLabel"
          :key="idx"
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          :align="idx < 5 ? 'center' : 'right'"
          :filters="item.filter && getFilterArr(item.filter)"
          :filtered-value="item.filter && getFilterValueArr(item.filter)"
          :column-key="item.columnKey && item.columnKey"
          :formatter="item.formatter ? item.formatter : isUsedFormatter(idx) ? dataFormat : null"
        ></el-table-column>
      </el-table>
    </div>
    </div>
    
  </div>
</template>

<script>
import DatePickerGroup from "@/components/DatePickerGroup";
import moment from "moment";
import locale from "@/helpers/locale";
import { toThousands, rounding, weekLocaleArray } from "@/utils/common";
import {
  getStockReportService,
  getLogListService,
} from "@/helpers/service/api/inventory";
import { getSystemSetting } from "@/helpers/service/api/common";
import "@/assets/style/inventory.less";
import { getFormatNum } from '@/utils/math'
import { getCinemaDailyListService } from "@/helpers/service/api/theaterDailyShow.js";
const inventoryTypeMapping = {
  commercial: locale("inventory.commercial"),
  ingredient: locale("inventory.ingredient"),
  concession: locale("inventory.concession"),
};

export default {
  // components: {
  //   DatePickerGroup
  // },
  computed: {
    today() {
      return this.$moment().valueOf();
    },
  },
  data() {
    return {
      printObj: {
        popTitle: this.$locale('sideMenu.reports.inventory'),
        id: "print"
      },
      cinemaId: "",
      timeRange: "",
      cinemaName: "",
      brandName: "",
      createTime: "",
      filters_in: [],
      filters_group: [],
      inventoryTypeArr: [
        {
          text: this.$locale("inventory.commercial"),
          value: "commercial"
        },
        {
          text: this.$locale("inventory.ingredient"),
          value: "ingredient"
        },
        {
          text: this.$locale("inventory.concession"),
          value: "concession"
        }
      ],
      inventoryIds: ["commercial", "ingredient", "concession"],
      groupIds: [],
      startTime: this.today,
      endTime: this.today,
      searchValue: "",
      count: 0,
      isCheckZero: true,
      isCheckBuy: true,
      typeArr: [],
      groupArr: [],
      tableData: [],
      tableLabel: [
        {
          width: 180,
          label: "販売分類",
          prop: "inventoryType",
          filter: "inventoryType",
          columnKey: "inventoryType"
        },
        {
          width: 200,
          label: "分類",
          prop: "cinemaDailySelective",
          filter: "cinemaDailySelective",
          columnKey: "cinemaDailySelective",
          formatter: (row, column, cellValue) => this.cdsFormatter(cellValue),
        },
        {
          width: 130,
          label: "商品コード",
          prop: "barCode"
        },
        {
          width: 200,
          label: this.$locale("inventoryLog.name"),
          prop: "name"
        },
        {
          width: 80,
          label: "単位",
          prop: "unit"
        },
        {
          width: 160,
          label: "在庫場所",
          prop: "stockPlace"
        },
        {
          width: 160,
          label: "前日残数",
          prop: "yesterdayResidual"
        },
        {
          width: 160,
          label: "入庫数",
          prop: "addStockQty"
        },
        {
          width: 160,
          label: "出庫数",
          prop: "deleteStockQty"
        },
        {
          width: 160,
          label: "調整数",
          prop: "adjustmentStockQty"
        },
        {
          width: 160,
          label: "現在庫数",
          prop: "stockQty"
        },
        {
          width: 160,
          label: "在庫単価",
          prop: "stockPrice"
        },
        {
          width: 160,
          label: "在庫金額",
          prop: "amount"
        },
        {
          width: 160,
          label: "回転率(%)",
          prop: "recycleTate"
        }
      ],
      testArr1: [],
      testArr2: [],
      testPosition1: 0,
      testPosition2: 0,
      roundType: "",
      pickerOptions: {
        disabledDate: this.disableMonth,
      },
      monthDate: Date.now().valueOf()
    };
  },
  created() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    this.getList();
    getSystemSetting().then(res => {
      this.roundType = res.data.round;
    });
  },
  mounted() {
    getCinemaDailyListService({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.groupArr = res.data.data.map(item => ({
          text: item.name,
          value: item.id
        }));
      }
    });
  },
  methods: {
    getList(inv, group) {
      this.testArr1 = [];
      this.testArr2 = [];
      this.typeArr = [];
      const startDate = this.formatDate(this.$moment(this.monthDate).startOf("month").valueOf());
      const endDate = this.formatDate(this.$moment(this.monthDate).endOf("month").valueOf());

      getStockReportService({
        cinemaId: this.cinemaId,
        startDate: this.$moment(this.monthDate).startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment(this.monthDate).endOf("month").format("YYYY-MM-DD"),
        inventoryIsZero: this.isCheckZero,
        publish: this.isCheckBuy,
        ...(inv ? { inventoryTypes: inv } : {}),
        ...(group ? { cinemaDailySelectives: group } : {})
      }).then(res => {
        this.tableData = res.data.stockRecords;
        this.tableData.forEach(item => {
          item.inventoryType = inventoryTypeMapping[item.inventoryType];
        });
        // this.tableData.forEach(item => {
        //   item.d_addStockQty = toThousands(item.addStockQty);
        //   item.deleteStockQty = Math.abs(item.deleteStockQty);
        //   item.d_deleteStockQty = toThousands(Math.abs(item.deleteStockQty));
        //   item.d_adjustmentStockQty = item.adjustmentStockQty > 0
        //     ? `+ ${toThousands(item.adjustmentStockQty)}` : toThousands(item.adjustmentStockQty);
        //   item.d_stockQty = toThousands(item.stockQty, 2);
        //   item.d_stockPrice = "¥ " + toThousands(rounding(item.stockPrice, this.roundType));

        //   if (item.stockPrice === "") {
        //     item.stockPrice = 0;
        //   }

        //   item.amount = item.stockQty * item.stockPrice;
        //   item.d_amount = "¥ " + toThousands(item.amount, 2);

        //   if (
        //     item.deleteStockQty === 0 &&
        //       item.yesterdayResidual === 0 &&
        //       item.addStockQty === 0
        //   ) {
        //     item.recycleTate = "0%";
        //   } else if (
        //     item.deleteStockQty /
        //           (item.yesterdayResidual + item.addStockQty) ===
        //         0
        //   ) {
        //     item.recycleTate = "0%";
        //   } else {
        //     item.recycleTate =
        //           Math.round((item.deleteStockQty /
        //               (item.yesterdayResidual + item.addStockQty)) *
        //               10000) /
        //             100 +
        //           "%";
        //   }
        // });
        if (this.groupArr.length === 0) {
          this.getGroupType();
        }

        if (this.tableData.length > 0) {
          this.dataGrouping();
        }
        this.rowspan(this.testArr1, this.testPosition1, "inventoryType");
        this.rowspan(this.testArr2, this.testPosition2, "cinemaDailySelective");
        this.cinemaName = res.data.cinemaName;
        this.brandName = res.data.brandName;
        this.createTime = moment(new Date(res.data.exportAt)).format("YYYY-MM-DD HH:mm:ss");
        let start = weekLocaleArray[new Date(startDate).getDay()];
        let end = weekLocaleArray[new Date(endDate).getDay()];
        this.timeRange = `${startDate}(${start}) ~ ${endDate}(${end})`;
      });
    },
    formatDate(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD");
    },
    getDate(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.startTime = startDate;
      }
      if (endDate) {
        this.endTime = endDate;
      }
    },
    rowspan(spanArr, position, spanName) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1);
          position = 0;
        } else if (
          this.tableData[index][spanName] ===
            this.tableData[index - 1][spanName]
        ) {
          spanArr[position] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          position = index;
        }
      });
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.testArr1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.inventoryType && row.inventoryType.indexOf("総計") > -1) {
          return {
            rowspan: 1,
            colspan: 6
          };
        }
        return {
          rowspan: _row,
          colspan: _col
        };

      }
      if (columnIndex === 1) {
        const _row = this.testArr2[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.cinemaDailySelective === undefined) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        if (row.cinemaDailySelective && row.cinemaDailySelective.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 5
          };
        }
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      if (columnIndex === 2) {
        if (row.barCode && row.barCode.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 4
          };
        }
        if (row.barCode === undefined) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 3) {
        if (row.name === undefined) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 4) {
        if (row.unit === undefined) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 5) {
        if (row.stockPlace === undefined) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getTypeArr() {
      const keyArr = [];
      const newArr = [];
      this.tableData.forEach(item => {
        this.typeArr.push({
          inventoryType: item.inventoryType,
          cinemaDailySelective: item.cinemaDailySelective
        });
        keyArr.push(item.inventoryType);
      });
      // 去重
      const newKey = new Set(keyArr);
      newKey.forEach(item => {
        const index = keyArr.findIndex(item2 => item2 === item);
        newArr.push(this.typeArr[index]);
      });
      this.typeArr = newArr;
    },
    getGroupType() {
      getLogListService({ cinemaId: this.cinemaId }).then(res => {
        this.groupArr = res.data;
        this.groupArr.forEach(item => {
          item.value = item.id;
          item.text = item.name;
          this.groupIds.push(item.id);
        });
      });
    },
    dataGrouping() {

      let finalData = [];
      // big type grouping
      let inventory = this.testGrouping(this.tableData, "inventoryType");
      let yesterdayResidual_t3 = 0,
        addStockQty_t3 = 0,
        deleteStockQty_t3 = 0,
        adjustmentStockQty_t3 = 0,
        stockQty_t3 = 0,
        amount_t3 = 0;
      // small type grouping
      inventory.forEach(inventoryItem => {
        let groupTypeArr = this.testGrouping(inventoryItem.item, "cinemaDailySelective");
        let yesterdayResidual_t2 = 0,
          addStockQty_t2 = 0,
          deleteStockQty_t2 = 0,
          adjustmentStockQty_t2 = 0,
          stockQty_t2 = 0,
          amount_t2 = 0;

        // forEach push data
        groupTypeArr.forEach(groupItem => {
          let yesterdayResidual_t = 0,
            addStockQty_t = 0,
            deleteStockQty_t = 0,
            adjustmentStockQty_t = 0,
            stockQty_t = 0,
            amount_t = 0;
          groupItem.item.forEach(item => {
            item.amount = item.stockPrice * item.stockQty;
            // item.recycleTate = (item.yesterdayResidual + item.addStockQty) === 0 ? 0 : (item.deleteStockQty / (item.yesterdayResidual + item.addStockQty));
            item.recycleTate = item.yesterdayResidual === 0 ? 0 : (item.yesterdayResidual - item.stockQty) / item.yesterdayResidual
            finalData.push(item);
            // calc small type total
            yesterdayResidual_t += item.yesterdayResidual;
            addStockQty_t += item.addStockQty;
            deleteStockQty_t += item.deleteStockQty;
            adjustmentStockQty_t += item.adjustmentStockQty;
            stockQty_t += item.stockQty;
            amount_t += item.amount;
          });
          // add small type total
          finalData.push({
            inventoryType: inventoryItem.inventoryType,
            cinemaDailySelective: groupItem.cinemaDailySelective,
            barCode: `${this.$locale("global.total")}(${this.cdsFormatter(groupItem.cinemaDailySelective)})`,
            yesterdayResidual: yesterdayResidual_t,
            addStockQty: addStockQty_t,
            deleteStockQty: deleteStockQty_t,
            adjustmentStockQty: adjustmentStockQty_t,
            stockQty: stockQty_t,
            stockPrice: null,
            amount: amount_t,
            // recycleTate: (yesterdayResidual_t + addStockQty_t) === 0 ? 0 : (deleteStockQty_t / (yesterdayResidual_t + addStockQty_t))
            recycleTate: yesterdayResidual_t === 0 ? 0 : (yesterdayResidual_t - stockQty_t) / yesterdayResidual_t
          });
          // calc big type total
          yesterdayResidual_t2 += yesterdayResidual_t;
          addStockQty_t2 += addStockQty_t;
          deleteStockQty_t2 += deleteStockQty_t;
          adjustmentStockQty_t2 += adjustmentStockQty_t;
          stockQty_t2 += stockQty_t;
          amount_t2 += amount_t;
        });
        // calc all total
        yesterdayResidual_t3 += yesterdayResidual_t2;
        addStockQty_t3 += addStockQty_t2;
        deleteStockQty_t3 += deleteStockQty_t2;
        adjustmentStockQty_t3 += adjustmentStockQty_t2;
        stockQty_t3 += stockQty_t2;
        amount_t3 += amount_t2;
        // add big type total
        finalData.push({
          cinemaDailySelective: `${this.$locale("global.total")}${inventoryItem.inventoryType}`,
          inventoryType: inventoryItem.inventoryType,
          yesterdayResidual: yesterdayResidual_t2,
          addStockQty: addStockQty_t2,
          deleteStockQty: deleteStockQty_t2,
          adjustmentStockQty: adjustmentStockQty_t2,
          stockQty: stockQty_t2,
          stockPrice: null,
          amount: amount_t2,
          // recycleTate: (yesterdayResidual_t2 + addStockQty_t2) === 0 ? 0 : (deleteStockQty_t2 / (yesterdayResidual_t2 + addStockQty_t2))
          recycleTate: yesterdayResidual_t2 === 0 ? 0 : (yesterdayResidual_t2 - stockQty_t2) / yesterdayResidual_t2
        });
      });
      // add all total
      finalData.push({
        inventoryType: this.$locale("global.total2"),
        yesterdayResidual: yesterdayResidual_t3,
        addStockQty: addStockQty_t3,
        deleteStockQty: deleteStockQty_t3,
        adjustmentStockQty: adjustmentStockQty_t3,
        stockQty: stockQty_t3,
        stockPrice: null,
        amount: amount_t3,
        // recycleTate: (yesterdayResidual_t3 + addStockQty_t3) === 0 ? 0 : (deleteStockQty_t3 / (yesterdayResidual_t3 + addStockQty_t3))
        recycleTate: yesterdayResidual_t3 === 0 ? 0 : (yesterdayResidual_t3 - stockQty_t3) / yesterdayResidual_t3
      });
      // set finalData override tableData
      this.tableData = finalData;
    },
    getFilterArr(type) {
      switch (type) {
      case "inventoryType":
        return this.inventoryTypeArr;
      case "cinemaDailySelective":
        return this.groupArr;
      default:
        break;
      }
    },
    getFilterValueArr(type) {
      switch (type) {
      case "inventoryType":
        return this.inventoryIds;
      case "cinemaDailySelective":
        return this.groupIds;
      default:
        break;
      }
    },
    filter(value) {
      let keys = Object.keys(value);
      let [ type ] = keys;
      if (type === "inventoryType") {
        this.filters_in = value[type];
      } else {
        this.filters_group = value[type];
      }
      this.getList(this.filters_in, this.filters_group);
    },
    search() {
      this.getList(this.filters_in, this.filters_group);
    },
    dataFormat(row, column) {
      const { property } = column;
      switch(property) {
      case "yesterdayResidual":
        return row.yesterdayResidual === null ? "/" : getFormatNum(row.yesterdayResidual, this.roundType).toLocaleString();
      case "addStockQty":
        return row.addStockQty === null ? "/" : getFormatNum(row.addStockQty, this.roundType).toLocaleString();
      case "deleteStockQty":
        return row.deleteStockQty === null ? "/" : getFormatNum(row.deleteStockQty, this.roundType).toLocaleString();
      case "adjustmentStockQty":
        return row.adjustmentStockQty === null ? "/" : getFormatNum(row.adjustmentStockQty, this.roundType).toLocaleString();
      case "stockQty":
        return row.stockQty === null ? "/" : getFormatNum(row.stockQty, this.roundType).toLocaleString();
      case "stockPrice":
        return row.stockPrice === null ? "/" : "¥" + getFormatNum(row.stockPrice, this.roundType).toLocaleString();
      case "amount":
        return "¥" + getFormatNum(row.amount, this.roundType).toLocaleString();
      case "recycleTate":
        return row.recycleTate === null ? "/" : getFormatNum(row.recycleTate, this.roundType) * 100 + "%";
      default:
        break;
      }
    },
    isUsedFormatter(idx) {
      return idx > 5;
    },
    testGrouping(arr, type) {
      let map = {},
        dest = [];
      arr.forEach(arrItem => {
        let ai = arrItem;
        if (!map[ai[type]]) {
          dest.push({
            [type]: ai[type],
            ...(type === "cinemaDailySelective" ? { cinemaDailySelective: ai.cinemaDailySelective } : {}),
            item: [ ai ]
          });
          map[ai[type]] = ai;
        } else {
          dest.forEach(destItem => {
            let dj = destItem;
            if (dj[type] === ai[type]) {
              dj.item.push(ai);
              return;
            }
          });
        }
      });
      return dest;
    },
    cdsFormatter(_val) {
      if (!_val) { return ""; }

      const _target = this.groupArr.find(_cds => _cds.value === _val) || {};
      return _target.text || _val;
    },
    disableMonth(time) {
      return time > Date.now();
    }
  },
};
</script>
